export default "__VITE_ASSET__wWQHbGvr__"